<template>
  <footer class="py-[60px] relative">
    <div class="container">
      <div class="grid md:grid-cols-6 grid-cols-1 gap-6">
        <div class="md:col-span-2">
          <div class="mt-4">
            <span class="text-xl font-bold">DentalSales</span>
            <p class="text-muted mt-6">
              2022-2023 © DentalSales.ru
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
